export const CIPTableFormSchema = {
    benefitArea:"",
    benefitType:"",
    metric:"",
    uom:"",
    verifier:{
        email: ""
    },
    comments:"",
    id:"",
    buttonStatus:true,
    mode:"",
    verifierStatus:false,
}